export const indiaProps: Intl.NumberFormatOptions = {
  style: 'currency',
  currency: 'INR',
  unitDisplay: 'short',
  notation: 'compact',
};

export default indiaProps;
